import Header from '../../components/Header'
import HeaderImage from '../../images/mission-img.jpg'
import './class.css'

const Class = () => {
  return (
    <>
      <Header title="Classes" image={HeaderImage}>
        In-person and online — find the format that works for you.
      </Header>
      <section className="classes-section">
        <div className="container classes-grid">
          <div className="classes-col">
            <p className="classes-label">In Studio</p>
            <h2 className="classes-title">Flourish Yoga &amp; Wellness</h2>
            <p className="classes-body">Check the NEW class roster for Tricia's classes on the home page.</p>
            <address className="classes-detail">
              6798 Crosswinds Dr N, D-106<br/>
              St. Petersburg, FL 33710
            </address>
          </div>
          <div className="classes-divider" />
          <div className="classes-col">
            <p className="classes-label">Online</p>
            <h2 className="classes-title">Weekend classes</h2>
            <p className="classes-body">The weekend classes that support your home practice, wherever you are.</p>
            <p className="classes-detail">
              Saturday at 8:15am<br/>
              Sunday at 10am
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default Class
